import { render, staticRenderFns } from "./SetAccount.vue?vue&type=template&id=6cdb3ea0&scoped=true&"
import script from "./SetAccount.vue?vue&type=script&lang=js&"
export * from "./SetAccount.vue?vue&type=script&lang=js&"
import style0 from "./SetAccount.vue?vue&type=style&index=0&id=6cdb3ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdb3ea0",
  null
  
)

export default component.exports